import { useState, useEffect } from "react";
import { IconButton, Tooltip } from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { db, doc, updateDoc } from "../firebaseConfig";
import { functions, httpsCallable } from "../firebaseConfig";
import EmailModalV2 from "./EmailModalV2";
import DateSelectorDialog from "../GlobalComponents/DateSelectorDialog";
import {
  parseDate,
  parseImages,
  parseAngles,
  parseLooks,
  getJobTypes,
} from "./emailUtils";

import { useAtom } from "jotai";
import { currentStaffDataAtom } from "../-Atoms";

const FirstConfirmationEmailV2 = ({
  open,
  onClose,
  confirmationEmailData,
  theme,
}) => {
  const [currentStaffData] = useAtom(currentStaffDataAtom);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [dateDialogOpen, setDateDialogOpen] = useState(false);
  const [emailTemplate, setEmailTemplate] = useState("");

  const sendEmail = httpsCallable(functions, "sendEmail");

  // Generate the email HTML template
  const generateEmailTemplate = () => {
    if (!confirmationEmailData?.jobData || !confirmationEmailData?.clientData) {
      return "";
    }

    const mainJobDate = parseDate(confirmationEmailData.jobData);
    const additionalJobsHtml = selectedJobs
      .map(
        (job) =>
          `<p style="line-height: 23px; margin: 16px 0;"><strong><span style="color: rgb(255, 0, 0);">${job.label}</span></strong></p>`
      )
      .join("");

    const jobTypes = getJobTypes(confirmationEmailData.jobData, selectedJobs);

    const showProduct = jobTypes.some(
      (type) => type && type.includes("-P") && !type.includes("-PC")
    );
    const showLife = jobTypes.some((type) => type && type.includes("-L"));
    const showVideo = jobTypes.some((type) => type && type.includes("-V"));
    const showCreative = jobTypes.some(
      (type) => type && (type.includes("-LC") || type.includes("-PC"))
    );

    return `
      <div style="max-width: 700px; margin: 0 auto; background-color: rgb(255, 255, 255); padding: 2.5rem; border-radius: 0.75rem; box-shadow: 0 4px 6px -1px rgb(0, 0, 0, 0.1), 0 2px 4px -2px rgb(0, 0, 0, 0.1); text-align: center; margin-top: 2.5rem; margin-bottom: 2.5rem;">
        
        <div style="text-align: left; margin-bottom: 20px;">
<p style="margin: 10px; color: black; font-size: 14px;">Hi</p>

<p style="margin: 10px; color: black; font-size: 14px;">I hope you've had a great start to the week!</p>
  

<p style="margin: 10px; color: black; font-size: 14px;">I'm just getting in touch to confirm your upcoming booking.</p>
  

<p style="margin: 10px; color: black; font-size: 14px;">Can you please review and confirm the below.</p>
  

<p style="margin: 10px; color: black; font-size: 14px;">Best</p>

<p style="margin: 10px; color: black; font-size: 14px;">${
      currentStaffData.firstName === "Amy"
        ? "Amy x"
        : currentStaffData.firstName
    }</p>
        </div>
        
        <div style="background-color: rgb(255, 255, 255); border: 1px solid #eaeaea; border-radius: 0.5rem; padding: 40px; margin-bottom: 20px;">
          <div style="margin-bottom: 40px; margin-top: -20px;">
            <img alt="ITS LOGO" src="https://www.imagesthatsell.com.au/ITS_LOGO_BLACK%20BLACK.jpg" width="100" style="margin: 0 auto; display: block;" />
          </div>
          
          <h1 style="font-size: 18px; font-weight: 700; color: rgb(17, 24, 39); margin-top: 2px; margin-bottom: 2px;">BOOKING CONFIRMATION</h1>
          
          <p style="font-size: 14px; line-height: 24px; margin: 16px 0; color: rgb(17, 24, 39); font-weight: bold;">
            PLEASE CHECK THE FOLLOWING DETAILS ARE CORRECT AND CONFIRM YOUR BOOKING:
          </p>
          
          <p style="line-height: 23px; margin: 16px 0;">
            <strong><span style="color: rgb(255, 0, 0);">${mainJobDate}</span></strong>
          </p>
          
          ${additionalJobsHtml}
          
          <p style="font-size: 14px; line-height: 24px; margin: 16px 0; color: rgb(55, 65, 81);">
            So we can ensure we have sufficient time allocated for your shoot, please confirm shot counts inclusive of all angles required in the below formats.
          </p>
          
          <p style="font-size: 14px; line-height: 24px; margin: 16px 0; color: rgb(55, 65, 81);">
            We can then review and come back for any required amendments to the above booking.
          </p>
          
          ${
            showProduct
              ? `
          <div>
            <p style="color: black;"><strong><span style="color: rgb(65, 105, 225);">PRODUCT (EXAMPLE FORMAT ONLY)</span></strong></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">20</span> <span style="color: rgb(65, 105, 225);">x GHOST MANNEQUIN APPAREL - </span><span style="color: rgb(255, 102, 0);">FRONT ONLY</span></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">5</span> <span style="color: rgb(65, 105, 225);">x BAGS @</span> <span style="color: rgb(255, 102, 0);">3</span> <span style="color: rgb(65, 105, 225);">ANGLES EACH</span></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">5</span> <span style="color: rgb(65, 105, 225);">x SHOES @</span> <span style="color: rgb(255, 102, 0);">3</span> <span style="color: rgb(65, 105, 225);">ANGLES EACH</span></p>
            <p style="color: black;"><span style="color: rgb(65, 105, 225);">TOTAL =</span> <span style="color: rgb(255, 102, 0);">50</span> <span style="color: rgb(65, 105, 225);">SHOTS</span></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">*Bookings are based on shot counts supplied at time of booking</span></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">*Additional shots may require additional time</span></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">*Minimum booking = 10 SKUs</span></p>
          </div>
          <br>
          `
              : ""
          }
          
          ${
            showLife
              ? `
          <div>
            <p style="color: black;"><strong><span style="color: rgb(65, 105, 225);">LIFE (EXAMPLE FORMAT ONLY)</span></strong></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">${parseLooks(
              confirmationEmailData.jobData,
              confirmationEmailData.clientData
            )}</span> x LOOKS @ <span style="color: rgb(255, 102, 0);">${parseAngles(
                  confirmationEmailData.jobData,
                  confirmationEmailData.clientData
                )}</span> ANGLES = <span style="color: rgb(255, 102, 0);">${
                  parseImages(
                    confirmationEmailData.jobData,
                    confirmationEmailData.clientData,
                    "dayType"
                  ) || "240"
                }</span> FILES</p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">*ITS package deals: 4 x hours = ${
              confirmationEmailData.clientData.halfDayRate?.images || "120"
            } files OR 8 x hours = ${
                  confirmationEmailData.clientData.fullDayRate?.images || "240"
                } files</span></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">*Inclusive of 1 x hour setup/HMU.</span></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">*Please advise if overtime is required</span></p>
          </div>
          <br>
          `
              : ""
          }
          
          ${
            showVideo
              ? `
          <div>
            <p style="color: black;"><strong><span style="color: rgb(65, 105, 225);">VIDEO (EXAMPLE FORMAT ONLY)</span></strong></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">5</span> <span style="color: rgb(65, 105, 225);">x ECOMM VIDEOS </span></p>
          </div>
          <br>
          `
              : ""
          }
          
          ${
            showCreative
              ? `
          <div>
            <p style="color: black;"><strong><span style="color: rgb(65, 105, 225);">CREATIVE (EXAMPLE FORMAT ONLY)</span></strong></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">${parseImages(
              confirmationEmailData.jobData,
              confirmationEmailData.clientData,
              "creativeDayType"
            )}</span> FILES</p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">*Inclusive of 1 x hour setup/HMU.</span></p>
            <p style="color: black;"><span style="color: rgb(255, 102, 0);">*Please advise if overtime is required</span></p>
          </div>
          <br>
          `
              : ""
          }
          
          <div style="display: flex; flex-direction: column; align-items: center; margin-top: 30px; margin-bottom: 20px;">
            <a href="http://www.imagesthatsell.com.au/docs/its-terms-and-conditions.pdf" target="_blank" style="line-height: 100%; text-decoration: none; display: inline-block; max-width: 100%; padding: 12px 20px; background-color: rgb(0, 0, 0); border-radius: 0.25rem; color: rgb(255, 255, 255); font-size: 12px; font-weight: 600; text-align: center;">
              <span style="max-width: 100%; display: inline-block; line-height: 120%; text-transform: uppercase;">TERMS & CONDITIONS</span>
            </a>
          </div>
        </div>
      </div>
    `;
  };

  const handleSend = async (emailData) => {
    try {
      const result = await sendEmail({
        emailBody: emailData.htmlContent,
        fromEmail: "bookings@imagesthatsell.com.au",
        toEmails: emailData.to,
        ccEmails: emailData.cc,
        bccEmails: emailData.bcc,
        replyToEmails: emailData.replyTo,
        subject: emailData.subject,
        attachments: emailData.attachments || [],
      });

      if (result.data.error) {
        throw new Error(result.data.errortext);
      } else {
        // Update main job status to 'pending'
        await updateDoc(doc(db, "JobData", confirmationEmailData.jobData.id), {
          confirmationStatus: "pending",
        });

        // Update all selected jobs status to 'pending'
        const updatePromises = selectedJobs.map((job) =>
          updateDoc(doc(db, "JobData", job.id), {
            confirmationStatus: "pending",
          })
        );
        await Promise.all(updatePromises);

        onClose();
      }
    } catch (error) {
      console.error("Error sending email:", error);
      throw error;
    }
  };

  // Update email template when selectedJobs changes
  useEffect(() => {
    setEmailTemplate(generateEmailTemplate());
  }, [selectedJobs]);

  // Custom toolbar button for Select Dates functionality
  const selectDatesButton = (
    <Tooltip title="Select Dates">
      <IconButton
        size="medium"
        onClick={() => setDateDialogOpen(true)}
        sx={{
          color: "inherit",
          borderRadius: "50%",
          "&:hover": {
            bgcolor: "rgba(255,255,255,0.1)",
          },
        }}
      >
        <DateRangeIcon fontSize="medium" />
      </IconButton>
    </Tooltip>
  );

  if (!confirmationEmailData?.jobData || !confirmationEmailData?.clientData) {
    return null;
  }

  return (
    <>
      <DateSelectorDialog
        open={dateDialogOpen}
        onClose={() => setDateDialogOpen(false)}
        selectedJobs={selectedJobs}
        setSelectedJobs={setSelectedJobs}
        theme={theme}
        confirmationEmailData={confirmationEmailData}
      />

      <EmailModalV2
        open={open}
        onClose={onClose}
        initialTo={confirmationEmailData.clientData.contacts || []}
        initialCc={[
          { name: "Adam Flipp", email: "adam@imagesthatsell.com.au" },
          { name: "Jodie Rogers", email: "jodie@imagesthatsell.com.au" },
        ]}
        initialBcc={[]}
        template={emailTemplate || generateEmailTemplate()}
        subject="Booking Confirmation"
        onSend={handleSend}
        customButtons={selectDatesButton}
        fromEmail="bookings@imagesthatsell.com.au"
        jobActions={{
          type: "first-confirmation",
          mainJobId: confirmationEmailData.jobData.id,
          selectedJobIds: selectedJobs.map((job) => job.id),
          updates: { confirmationStatus: "pending" },
        }}
      />
    </>
  );
};

export default FirstConfirmationEmailV2;
